export const DashboardFooter = (props) => {
  const { content } = props
  return (
    <div className="dashboard-footer">
      <b color="black">{content?.companyName}</b>
    </div>
  )
}
